import React from "react";
import { Container } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { useTranslation } from "@/lib/i18n";
import { dashboardsQuery } from "@/features/shared/hooks";
import { AddFab as AddDashboardFab } from "@/features/admin/components";
import { NewDashboardDialog } from "@/features/admin/features/dashboards";
import NavigationToggle from "@/features/admin/components/navigation-toggle/NavigationToggle";
import AvatarCard from "@/features/shared/components/avatar-card/avatar-card";
import Fluid from "@/components/fluid/fluid";

const OverviewPage = () => {
  const { t } = useTranslation();
  const [dialogVisible, setDialogVisible] = React.useState(false);
  const dashboards = useQuery(dashboardsQuery()).data ?? [];

  return (
    <>
      <Container sx={{ mt: { xs: 2, md: 6 } }}>
        <NavigationToggle />
        <Fluid width={280} spacing={4}>
          {dashboards?.map((dashboard) => (
            <AvatarCard
              key={dashboard.id}
              to={`/admin/dashboard/${dashboard.id}`}
              name={dashboard.name}
              tags={[dashboard.extranet.name]}
              label={
                dashboard.active
                  ? t("admin.overview.item.active")
                  : t("admin.overview.item.inactive")
              }
            />
          ))}
        </Fluid>
        <AddDashboardFab
          onClick={() => setDialogVisible(true)}
          tooltip={t("admin.add_new_dashboard")}
        />
      </Container>
      <NewDashboardDialog open={dialogVisible} onClose={() => setDialogVisible(false)} />
    </>
  );
};

export default OverviewPage;
